import { render, staticRenderFns } from "./PaginationNavButtonContent.vue?vue&type=template&id=bbcbc540&"
import script from "./PaginationNavButtonContent.vue?vue&type=script&lang=js&"
export * from "./PaginationNavButtonContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports